var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.125 0 0 7.1875 0 16C0 24.875 7.125 32 16 32C24.8125 32 32 24.875 32 16C32 7.1875 24.8125 0 16 0ZM16 30C8.25 30 2 23.75 2 16C2 8.3125 8.25 2 16 2C23.6875 2 30 8.3125 30 16C30 23.75 23.6875 30 16 30ZM16 11.5C16.8125 11.5 17.5 10.875 17.5 10C17.5 9.1875 16.8125 8.5 16 8.5C15.125 8.5 14.5 9.1875 14.5 10C14.5 10.875 15.125 11.5 16 11.5ZM19 22H17V15C17 14.5 16.5 14 16 14H14C13.4375 14 13 14.5 13 15C13 15.5625 13.4375 16 14 16H15V22H13C12.4375 22 12 22.5 12 23C12 23.5625 12.4375 24 13 24H19C19.5 24 20 23.5625 20 23C20 22.5 19.5 22 19 22Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.608b9943a71d670b2def61d99f17fb4f.svg";
export { ForwardRef as ReactComponent };